import styled, { css } from 'styled-components/macro';
import { alertHollow } from '../../../assets/icons';

export const Wrapper = styled.div<{
  invalid: boolean;
  shadowOnlyFor?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;

  ${(props) =>
    props.invalid &&
    (!props.shadowOnlyFor
      ? css`
          input,
          textarea {
            border-radius: 8px;
            border: 1px solid #feb2b2;
            background: #ffffff;
            box-shadow: 0 0 0 4px #fee3e3;
          }
        `
      : css`
          ${props.shadowOnlyFor} {
            width: calc(100% - 8px);
            border: 1px solid #feb2b2;
            background: #ffffff;
            box-shadow: 0 0 0 4px #fee3e3;
          }
        `)}
`;

export const ErrorMsg = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #e53e3eff;

  &:before {
    content: url(${alertHollow});
    height: 16px;
    width: 16px;
  }
`;

export const Label = styled.label``;
